<template>
  <div>
    <v-card
      v-if="!header"
      :class="cardClass"
      tile
      :style="cardStyle"
      width="100%"
      @click="handleClick()"
    >
      <slot />
    </v-card>
    <v-card v-else :class="cardClass" tile :style="cardStyle">
      <slot />
    </v-card>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { MobileView } from '@/mixins';

export default {
  props: ['data', 'type', 'noMargin', 'tab', 'header', 'scrollWidth', 'click'],
  mixins: [MobileView],
  computed: {
    ...mapGetters({
      _client: 'account/getCurrentClient',
    }),
    cardClass() {
      if (this.noMargin || this.showMobileView) {
        return 'pa-4';
      } if (this.header) {
        return 'pa-4 my-4 ml-4 d-flex align-center';
      }
      return 'ma-4 pa-4';
    },
    cardStyle() {
      if (this.noMargin) {
        if (this.showMobileView) {
          return 'height:140px;';
        }
        return 'height:70px;';
      }
      if (this.showMobileView) {
        return `height:140px; margin-right: ${16 + this.scrollWidth}px;`;
      }
      return `height:70px; margin-right: ${16 + this.scrollWidth}px;`;
    },
  },
  methods: {
    handleClick() {
      if (
        (this.$router.history.current.name === 'Groups'
          || this.$router.history.current.name === 'Screens'
          || this.$route.name === 'Keys'
          || this.$route.name === 'Reports'
          || this.$router.history.current.name === 'Reconciliation')
        && (this.$router.shouldRoute === true
          || this.$router.shouldRoute === undefined)
      ) {
        if (this.tab) {
          this.$router.push(
            `/${this._client.client_name.toLowerCase().replace(/\s/g, '')}/${
              this.type
            }/${this.tab}/${this.data.uuid}`,
          );
        } else if (this.$route.name === 'Reports' && this.type === 'screens') {
          this.$router.push(
            `/${this._client.client_name.toLowerCase().replace(/\s/g, '')}/${
              this.type
            }/${this.data.screen_id}`,
          );
        } else {
          this.$router.push(
            `/${this._client.client_name.toLowerCase().replace(/\s/g, '')}/${
              this.type
            }/${this.data.uuid}`,
          );
        }
      }
      if (this.$router.shouldRoute === false) {
        this.$router.shouldRoute = true;
      }
    },
  },
};
</script>
